import React from 'react';

import {DataLoader, serializeJSONToString} from '../common';
import {useCurrentLocale} from '../containers';
import {useApiQuery} from '../hooks';

type Props = DataLoader;
export const PrefetchLoader: React.FC<Props> = (props) => {
  const {apiUrl, useLocale, children} = props;
  const currentLocale = useCurrentLocale();
  const apiParams: Record<string, any> = useLocale
    ? {
        language: typeof useLocale === 'string' ? useLocale : currentLocale,
      }
    : {};
  useApiQuery([apiUrl, serializeJSONToString(apiParams)], null, {
    axiosConfig: {
      url: apiUrl,
      params: new URLSearchParams(apiParams),
    },
  });
  return <>{children}</>;
};
